import { render, staticRenderFns } from "./AvatarLiveCaption.vue?vue&type=template&id=688cdc72&scoped=true&"
import script from "./AvatarLiveCaption.vue?vue&type=script&lang=ts&"
export * from "./AvatarLiveCaption.vue?vue&type=script&lang=ts&"
import style0 from "./AvatarLiveCaption.vue?vue&type=style&index=0&id=688cdc72&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "688cdc72",
  null
  
)

export default component.exports